import { OrderWizard } from '@/features/orders/OrderWizard'

export function OrderNew() {
  return <OrderWizard />
}
